import axios from '../axios.js';

var api = {
  //Banner
  getBannerList(params){
    return axios.post('index/banner/list',params)
  },
  //老师列表
  getTeacher(params){
    return axios.post('index/user/teacherList',params)
  },
  //口碑列表
  getPublicList(){
    return axios.post('index/praise/list')
  },
  //右侧标签
  rightCon(){
    return axios.post('index/activity/detail')
  },
  //备考平台
  examPlatform(){
    return axios.post('index/platform/list')
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/home.js